/** Remove model/tool protocol scaffolding that must never be user-visible. */
export function sanitizeAssistantText(text: string): string {
  if (!text) return text;

  return text
    // DSML protocol tags emitted by some model adapters, including spaced
    // delimiters. Remove tags line-by-line; never swallow later user prose.
    .replace(/<\s*\|\s*DSML\s*\|\s*\/?(?:function_calls|invoke|parameter)[^>]*(?:>|$)/gi, '')
    // XML-like fragments when the adapter omitted the outer DSML wrapper.
    .replace(/<\/?(?:function_calls|invoke|parameter)\b[^>]*>/gi, '')
    // Line-oriented protocol fragments observed in streamed output.
    .replace(/^\s*(?:function_calls|invoke\s+name\s*=|parameter\s+name\s*=).*$/gim, '')
    .replace(/\n{3,}/g, '\n\n')
    .trim();
}
